import { ItemsSlide } from './itemsSlide.js';

export function TwitterSlide(timeout) {
	this.timeout = timeout;
	this.element = null;
}
TwitterSlide.prototype = new ItemsSlide();

TwitterSlide.prototype.elementCreated = function(element) {
	this.element = element;
	this.elementCreatedBase(element);
};
TwitterSlide.prototype.prepare = function() {
	var self = this;
	var xhr = new XMLHttpRequest();
	xhr.open('GET', '/api/twitter');
	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			self.clearItems();
			try {
				var response = JSON.parse(xhr.responseText);
				self.addItems(response.tweets);
			}
			catch (err) {
				self.addItems([{
					'screen_name': 'FDProAmJam',
					'retweet': false,
					'text': 'Failed to load tweets'
				}])
			}
		}
	};
	xhr.send(null);
};
TwitterSlide.prototype.show = function() {
	this.startItems();
};
TwitterSlide.prototype.hide = function() {
	this.stopItems();
};
TwitterSlide.prototype.createElement = function(tweet) {
	var tweetTemplate = document.querySelector('#tweet');
	var tweetSection = tweetTemplate.content.cloneNode(true).querySelector('.tweet');
	if (tweet.retweet) {
		tweetSection.classList.add('retweet');
	}
	var title = tweetSection.querySelector('h1');
	title.innerText = tweet.screen_name;
	var content = tweetSection.querySelector('p');
	content.innerText = tweet.text;

	return tweetSection;
};
